module.exports = __webpack_public_path__ + "static/Abacus Mitarbeitergespräche LEHMANNPARTNER-52890309bd559fb55c4ca9f94b246faf.pdf";